var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.talalatok.length)?_c('div',[_vm._v("\n    s\n    "),_c('ul',_vm._l((_vm.talalatok),function(e){return _c('li',[_vm._v("\n            "+_vm._s(e.value)+"\n            ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }